"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOLTIP_COMMON_PROPS = void 0;
var dataHooks_1 = require("../dataHooks");
exports.TOOLTIP_COMMON_PROPS = {
    'data-hook': dataHooks_1.colorPickerItemTooltipDataHook,
    moveBy: { x: 0, y: 2 },
    appendTo: 'window',
    placement: 'top',
};
//# sourceMappingURL=tooltipCommonProps.js.map